import * as React from 'react';
import { FontManager, FontStatus } from '../../utils/fontManager';
import './FontLoadingIndicator.scss';

interface Props {
  fontManager: FontManager;
}

const FontLoadingIndicator: React.FC<Props> = ({ fontManager }) => {
  const [loadingFonts, setLoadingFonts] = React.useState<Array<{ id: string; name: string; progress: number }>>([]);

  React.useEffect(() => {
    const updateLoadingFonts = () => {
      const allFonts = fontManager.getAllFontsState();
      const loading: Array<{ id: string; name: string; progress: number }> = [];

      allFonts.forEach((state, id) => {
        if (state.status === FontStatus.Loading) {
          loading.push({
            id,
            name: state.definition.name,
            progress: state.progress
          });
        }
      });

      setLoadingFonts(loading);
    };

    // 初始化
    updateLoadingFonts();

    // 订阅字体状态变化
    const unsubscribe = fontManager.onFontStateChange(() => {
      updateLoadingFonts();
    });

    return () => {
      unsubscribe();
    };
  }, [fontManager]);

  if (loadingFonts.length === 0) {
    return null;
  }

  return (
    <div className="font-loading-indicator">
      <div className="font-loading-content">
        <h3>Loading Fonts...</h3>
        {loadingFonts.map(font => (
          <div key={font.id} className="font-loading-item">
            <div className="font-name">{font.name}</div>
            <div className="progress-bar">
              <div
                className="progress-fill"
                style={{ width: `${font.progress}%` }}
              />
            </div>
            <div className="progress-text">{Math.round(font.progress)}%</div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default FontLoadingIndicator;
